// extracted by mini-css-extract-plugin
export default {"switch":"app-roles-RoleAbilitySwitch-RoleAbilitySwitch-module__X9hGZZB2s9FyWjnj984w"};